import React, { FC } from 'react';

import { Box } from '@mui/system';
import { FormikProps } from 'formik';

import { TextFieldVariants } from '../../../../../../helpers/Constants';
import genericClasses from '../../../../../../theme/GenericClasses';
import CustomTextField from '../../../../../common/CustomTextField';

import styles from '../../styles';

const { filled } = TextFieldVariants;

interface IReadOnlyNavigationField {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikProps<any>;
}

// LABEL LESS ROW KEPT ALIGNED UNDER THE FIELD IT DESCRIBES
const ReadOnlyNavigationField: FC<IReadOnlyNavigationField> = ({
  name,
  formik,
}) =>
  (
    <Box sx={styles.readOnlyFieldContainer}>
      <Box sx={styles.readOnlyFieldSpacer} />
      <CustomTextField
        name={name}
        formik={formik}
        disabled
        variant={filled}
        id={name}
        customClass={styles.readOnlyField}
        customTextFieldStyle={genericClasses.customFilledInput}
      />
    </Box>
  );

export default ReadOnlyNavigationField;
